import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { BillingScreen } from "../../screens/settings-money/index.ts";

/**
 * `/settings/billing`: plan and billing (see `BillingScreen`). `?tab=plans` opens All plans (the plan is the default and
 * has no parameter); coming back from Stripe's payment page the address carries `session_id`. The loader starts the
 * plan and the plans.
 */
export const Route = createFileRoute("/_app/settings/billing")({
  validateSearch: (search: Record<string, unknown>): { session_id?: string; tab?: "plans" } => ({
    ...(typeof search.session_id === "string" && /^cs_[A-Za-z0-9_]+$/.test(search.session_id)
      ? { session_id: search.session_id }
      : {}),
    ...(search.tab === "plans" ? { tab: "plans" as const } : {}),
  }),
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.prefetchQuery(actions.queryOptions("billing.getOverview", {})),
      context.queryClient.prefetchQuery(actions.queryOptions("billing.listPlans", {})),
    ]),
  component: BillingScreen,
});
